var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('b-row',_vm._l((_vm.sourcetype.set1),function(html,index){return _c('b-col',{key:index},[_c('iframe',{attrs:{"id":"jupyter","width":"600","height":"400","src":'./html/' + html,"frameborder":"1"}})])}),1),_c('hr')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }